/** Core data model for the food inventory. */

export const STORAGE_LOCATIONS = ["fridge", "freezer", "pantry"] as const;
export type StorageLocation = (typeof STORAGE_LOCATIONS)[number];

/** The seven tiles on the add grid, in the order they appear. */
export const FOOD_CATEGORIES = [
  "produce",
  "meat",
  "dairy",
  "pantry",
  "frozen",
  "drinks",
  "other",
] as const;
export type FoodCategory = (typeof FOOD_CATEGORIES)[number];

export const UNITS = ["pcs", "g", "kg", "ml", "l", "pack"] as const;
export type Unit = (typeof UNITS)[number];

export const LOCATION_LABELS: Record<StorageLocation, string> = {
  fridge: "Fridge",
  freezer: "Freezer",
  pantry: "Pantry",
};

export interface FoodItem {
  id: string;
  name: string;
  category: FoodCategory;
  location: StorageLocation;
  quantity: number;
  unit: Unit;
  /** ISO calendar date, "YYYY-MM-DD". */
  purchaseDate: string;
  /** ISO calendar date, computed from category + location + purchaseDate. */
  estimatedExpiryDate: string;
  /** ISO calendar date. Set when the user knows better than the estimate. */
  userExpiryOverride?: string;
  /**
   * A downscaled JPEG data URL, roughly 10–20KB. Never the original photo —
   * see src/lib/image/downscalePhoto.ts for why.
   */
  photo?: string;
  notes?: string;
}

/** What the add form edits: no id, nothing computed yet. */
export interface FoodItemDraft {
  name: string;
  category: FoodCategory;
  location: StorageLocation;
  /**
   * A string, not a number, so the input can be empty while the user is
   * retyping it. Parsed and range-checked in validateDraft.
   */
  quantity: string;
  unit: Unit;
  purchaseDate: string;
}
